/**
 * Lightweight client-side cooldown for abuse-prone UI actions.
 * Not a security boundary — complements server/Firestore enforcement.
 */

const STORAGE_PREFIX = 'floora:rate:';

/**
 * @param {string} key
 * @param {number} cooldownMs
 * @returns {{ allowed: boolean, retryAfterMs: number }}
 */
export function checkClientCooldown(key, cooldownMs) {
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
    const last = raw ? Number(raw) : 0;
    const elapsed = Date.now() - last;
    if (last > 0 && elapsed < cooldownMs) {
      return { allowed: false, retryAfterMs: cooldownMs - elapsed };
    }
    return { allowed: true, retryAfterMs: 0 };
  } catch {
    return { allowed: true, retryAfterMs: 0 };
  }
}

/** @param {string} key */
export function markClientCooldown(key) {
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, String(Date.now()));
  } catch {
    // ignore quota / private mode
  }
}
